import { I18n } from '@app/i18n/strings-keys';
import { IModalDialogOptions } from '@app/shared/types';
import { BTN_CANCEL, BTN_YES } from '@app/text-content/button-templates';
import { MODAL_TEMPLATE_CONFIRM } from '@app/text-content/modal-templates';
import { BTN_PRIMARY_CLASS } from '@config/index';

export const clearCountModalOptions: IModalDialogOptions = {
  ...MODAL_TEMPLATE_CONFIRM,
  text: I18n.ConfirmMessages.AreYouSureYouWantToClearAllCount,
  buttons: [
    {
      ...BTN_YES,
      class: BTN_PRIMARY_CLASS,
    },
    BTN_CANCEL,
  ],
};
